// Import: Middleware Action & Custom Types
import { CLEAN_LIST_FREE_TRIAL_IPB, CLEAN_LIST_FREE_TRIAL_IPB_ERROR } from '_models/redux/types';

// Action function
export const cleanListFreeTrialIpbClean = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_LIST_FREE_TRIAL_IPB,
      payload: undefined,
    });
  } catch {
    dispatch({
      type: CLEAN_LIST_FREE_TRIAL_IPB_ERROR,
      payload: undefined,
    });
  }
};
